import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	ofTotalCount: {
		id: 'jql-builder-basic-picker.async-select.pagination-details.of-total-count',
		defaultMessage: '{itemsCount} of {totalCount}',
		description: 'Total count of items.',
	},
});
